var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareConsultant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -2 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-553.000000, -306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_share_consultant",
    transform: "translate(551.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13494875,11.5999145 C7.84503172,11.5999145 7.56365969,11.4488525 7.40985109,11.178772 C7.18249516,10.7786866 7.32257078,10.2699585 7.72113039,10.0426025 L15.4536743,5.63372805 C15.8525391,5.40362547 16.3624878,5.54492187 16.5913696,5.94500734 C16.8187256,6.34509281 16.6786499,6.85382078 16.2800903,7.08117672 L8.54754641,11.4900513 C8.41632078,11.5651245 8.27502438,11.5999145 8.13494875,11.5999145 L8.13494875,11.5999145 Z",
    id: "Path",
    fill: "#A3C7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8650512,18.4749145 C15.7249756,18.4749145 15.5836792,18.4401245 15.4536743,18.3650513 L7.72113039,13.9561767 C7.32135008,13.7288208 7.18127437,13.218872 7.40985109,12.8200073 C7.63751219,12.4199219 8.14624023,12.2786255 8.54754641,12.508728 L16.2800903,16.9176025 C16.6798706,17.1449585 16.8199462,17.6549072 16.5913696,18.053772 C16.4363403,18.3238525 16.1549683,18.4749145 15.8650512,18.4749145 L15.8650512,18.4749145 Z",
    id: "Path",
    fill: "#A3C7F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.832520, 2.000000)",
    fill: "#1A73E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3349609,16.6662598 C18.3349609,18.5073852 16.8423462,20 15.0012207,20 C13.1600952,20 11.6674805,18.5073852 11.6674805,16.6662598 C11.6674805,14.8251343 13.1600952,13.3325195 15.0012207,13.3325195 C16.8423462,13.3325195 18.3349609,14.8251343 18.3349609,16.6662598 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3349609,3.33374023 C18.3349609,5.1748657 16.8423462,6.66748047 15.0012207,6.66748047 C13.1600952,6.66748047 11.6674805,5.1748657 11.6674805,3.33374023 C11.6674805,1.49261477 13.1600952,0 15.0012207,0 C16.8423462,0 18.3349609,1.49261477 18.3349609,3.33374023 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66748047,10 C6.66748047,11.8411255 5.1748657,13.3337402 3.33374023,13.3337402 C1.49261477,13.3337402 0,11.8411255 0,10 C0,8.15887453 1.49261477,6.66625977 3.33374023,6.66625977 C5.1748657,6.66625977 6.66748047,8.15887453 6.66748047,10 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareConsultant);
export default __webpack_public_path__ + "static/media/share-consultant.309a89d4cc46c928715676686b4ee961.svg";
export { ForwardRef as ReactComponent };